
import { mapActions } from 'vuex';
import Vue from 'vue';
import * as action from "@/store/actions";
import Top from "@/components/templates/Top.vue";
import { mapGetters } from 'vuex';
export default Vue.extend({
  name: 'WebphoneScreen',
  components: { Top },
  data() {
    return {
      selectedExtension: null,
      extensions: [],
      extenList: [],
    };
  },
  async mounted() {
    this.extenList = await this.getExtensionsList(action.EXTENSION_CONTROLLER);
    this.extensions = this.extenList
      .filter(ext => ext.portType === "WSS")
      .map(ext => ext.number);
  },
    computed: {
    ...mapGetters({
      webRtcServer: "auth/webRtcServer",
    }),
  },
  methods: {
    ...mapActions({
      getExtensionsList: "crudService/getList",
    }),
    abrirPopup() {
      const exten = this.extenList.find(ext => ext.number === this.selectedExtension);
      if (!exten) return;
      const profileName = exten.description || exten.number;
      const domain = this.webRtcServer?.trim()
        ? this.webRtcServer.trim()
        : window.location.hostname;
      const url = `https://hey.voipgroup.com:4443/?sipUser=${exten.corpId}_${exten.number}&sipServer=${domain}&port=4443&sipPassword=${exten.pass}&profileName=${profileName}&action=register&iconcolor=#d0021b&fontcolor=#f1f3f4`;

      const features = [
        'width=550',
        'height=650',
        'left=100',
        'top=100',
        'location=no',
        'menubar=no',
        'toolbar=no',
        'status=no',
        'resizable=no',
        'scrollbars=yes'
      ].join(',');

      const popup = window.open(url, 'WebPhone', features);
      if (popup && !popup.closed) {
        popup.focus();
      }
    }
  }
});
